import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableContainer,
  TablePagination,
} from '@mui/material'
import React, { ChangeEvent, MouseEvent, PropsWithChildren } from 'react'
import { useStyles } from './styles'

export interface ICount {
  count: number
}

interface ITableWrapper extends PropsWithChildren {
  totalRows: number
  rowsPerPage: number
  page: number
  modalIsOpen: boolean
  handleChangePage: (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => void
  handleChangeRowsPerPage: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => Promise<void>
  handleClose: () => void
  handleCloseDelete: () => void
}

const TableWrapper: React.FC<ITableWrapper> = ({
  page,
  rowsPerPage,
  totalRows,
  children,
  modalIsOpen,
  handleChangePage,
  handleChangeRowsPerPage,
  handleClose,
  handleCloseDelete,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <TableContainer className={classes.tableContainer}>
        <Table sx={{ borderCollapse: 'separate', borderColor: '#E4E4E4', width: '100%' }}>{children}</Table>
      </TableContainer>

      <TablePagination
        component='div'
        page={page}
        count={totalRows}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        labelRowsPerPage='Linhas por página: '
        rowsPerPageOptions={[10, 25, 50, 100]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        sx={{ '.MuiSvgIcon-root': { position: 'relative' } }}
      />

      <Dialog
        open={modalIsOpen}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Exclusão de Registro</DialogTitle>

        <DialogContent style={{ width: '500px' }}>
          <DialogContentText id='alert-dialog-description'>Deseja realmente excluir o registro?</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            variant='contained'
          >
            Não
          </Button>
          <Button
            onClick={handleCloseDelete}
            variant='contained'
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default TableWrapper
